//引入
import server from "../untils/request.js";
 //搜索接口
export const article = (params) => {
    return server({
        url: "/ArticleApi/ArticleListV2",
        method: "post" ,   
        data: params
    })
}
//文章详情
export const ArticleDetail = (params) => {
    return server({
        url: "/ArticleApi/Detail",
        method: "post" ,   
        data: params
    })
}
//专家列表
export const ExpertAllList = (params) => {
    return server({
        url: "/ExpertApi/ExpertList",
        method: "post" ,   
        data: params
    })
}
//专家详情
export const ExpertDetail = (params) => {
    return server({
        url: "/ExpertApi/ExpertDetail",
        method: "post" ,   
        data: params
    })
}
//专家详情总数
export const ExpertDetailAll = (params) => {
    return server({
        url: "/ExpertApi/ExpertAllList",
        method: "post" ,   
        data: params
    })
}
//资讯
export const NewsApi = (params) => {
    return server({
        url: "/ArticleApi/ArticleListByTag",
        method: "post" ,   
        data: params
    })
}
//年会视频
export const VideoTypeList = (params) => {
    return server({
        url: "/InterviewApi/VideoList",
        method: "post" ,   
        data: params
    })
}
//首页轮播图
export const HomeListV2 = (params) => {
    return server({
        url: "/IndexApi/HomeListV2",
        method: "post" , 
		data:params
    })
}
//获取某人的文章
export const ArticleExpertList = (params) => {
    return server({
        url: "/ArticleApi/ArticleExpertList",
        method: "post" ,   
		data: params
    })
}